var React = require('react');

function IconClose (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 7.05L16.95 6 12 10.95 7.05 6 6 7.05 10.95 12 6 16.95 7.05 18 12 13.05 16.95 18 18 16.95 13.05 12 18 7.05z"}));
}

IconClose.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconClose;

IconClose.default = IconClose;
